/**
 * Centralized waffle flag constants
 *
 * These flags control feature rollout across the application.
 */

/**
 * Flag to enable venue branding (custom themes, colors, fonts).
 */
export const WAFFLE_FLAG_BRANDED_PAGES = "enable_branded_pages";

/**
 * Flag to enable the AI chat plugin in the Puck website editor sidebar.
 * Venue-scoped — allows gradual rollout per venue.
 */
export const WAFFLE_FLAG_AI_WEBSITE_CHAT = "enable_ai_website_chat";

/**
 * Flag to enable one-click checkout (Apple Pay / Google Pay) on detail page modals.
 * Venue-scoped for A/B testing conversion impact.
 */
export const WAFFLE_FLAG_ONE_CLICK_CHECKOUT = "enable_one_click_checkout";

/**
 * Flag to allow one-click checkout even when custom questions are present.
 * Venue-scoped — off by default so custom questions block one-click checkout.
 */
export const WAFFLE_FLAG_ONE_CLICK_CHECKOUT_BYPASS_QUESTIONS =
  "enable_one_click_checkout_bypass_questions";

/**
 * Flag to enable section-based navigation tabs on attraction event pages.
 * When active, attraction sections replace the single "Tickets" tab.
 */
export const WAFFLE_FLAG_ATTRACTION_SECTIONS_NAV =
  "use_sections_for_attraction_page_nav";

/**
 * Flag to enable star rating display on event and organizer pages.
 */
export const WAFFLE_FLAG_RATING_DISPLAY = "enable_rating_display";

/**
 * Flag to enable the "highly recommended by X%" badge on event pages.
 */
export const WAFFLE_FLAG_RECOMMENDED_BADGE = "enable_recommended_badge";

/**
 * Flag to enable converting ticket delivery to electronic and resending QR codes.
 * Venue-scoped — shown in transaction actions when active.
 */
export const WAFFLE_FLAG_CONVERT_TO_ELECTRONIC_DELIVERY =
  "enable_convert_to_electronic_delivery";

/**
 * Flag to enable custom domain management on the Domains page.
 * Venue-scoped — controls visibility of the Domains sidebar nav item and page content.
 */
export const WAFFLE_FLAG_CUSTOM_DOMAINS = "enable_custom_domains";

/**
 * Flag to enable the refund protection upsell page.
 * Venue-scoped — allows gradual rollout per venue/client.
 */
export const WAFFLE_FLAG_REFUND_PROTECTION_UPSELL =
  "enable_refund_protection_upsell";
